import $ from 'jquery';
import videojs from 'video.js/dist/alt/video.core.novtt.js';

export const showVideoPreview = async (videoUrl) => {
  $('#canvas-container').hide();
  $('#video-container').fadeIn();

  videojs(
    'video-player',
    {
      fluid: true,
    },
    function onPlayerReady() {
      this.src(videoUrl);

      this.on('ended', function () {
        setTimeout(() => {
          $('#video-container').hide();
          $('#canvas-container').fadeIn();
        }, 1200);
      });
    }
  );
};
